import Vue from 'vue';
import {TranslateResult} from 'vue-i18n';
import i18n from '@/config/i18n';

class NotificationService {
  static success(message: string | TranslateResult): void {
    Vue.prototype.$awn.success(message, { labels: { success: i18n.t('SUCCESS') } });
  }

  static info(message: string | TranslateResult): void {
    Vue.prototype.$awn.info(message, { labels: { info: i18n.t('INFO') } });
  }

  static error(error?: any): void {
    if (error.response) {
      const unwrappedError = error.response.data.message;
      const isArray = Array.isArray(unwrappedError);
      const msg = isArray && unwrappedError.length > 0 ? unwrappedError[0] : unwrappedError;
      Vue.prototype.$awn.alert(msg, { labels: { alert: 'Błąd' } });
    }
  }

  static flatError(error: string | TranslateResult): void {
    Vue.prototype.$awn.alert(error, { labels: { alert: i18n.t('ERROR') } });
  }

  static warn(message: string | TranslateResult): void {
    Vue.prototype.$awn.warning(message, { labels: { warning: i18n.t('WARNING') } });
  }
}

export default NotificationService;
